import {
    ACTION_SET_TOKENS,
    ACTION_SET_TOKEN,
    ACTION_CREATE_TOKEN,
    ACTION_UPDATE_TOKEN,
} from '../actions/token';

const initialState = {
    items: [],
};

export default function token(state = initialState, { type, payload }) {
    const updateTokens = (token) => {
        return state.items.map((i) => (i._id !== token._id ? i : token));
    };

    switch (type) {
        case ACTION_SET_TOKENS:
            return { ...state, items: payload };
        case ACTION_SET_TOKEN:
            return { ...state, items: [...state.items, payload] };
        case ACTION_CREATE_TOKEN:
            return { ...state, items: [...state.items, payload] };
        case ACTION_UPDATE_TOKEN:
            return { ...state, items: updateTokens(payload) };
        default:
            return state;
    }
}
